import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL  = process.env.REACT_APP_SUPABASE_URL
  || "https://jwxrfrsowgwjmssguloa.supabase.co";
const SUPABASE_ANON = process.env.REACT_APP_SUPABASE_ANON_KEY
  || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp3eHJmcnNvd2d3am1zc2d1bG9hIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM4OTk5OTcsImV4cCI6MjA4OTQ3NTk5N30.35j6BsP70axGbB4h3kFQVOBqCVSv0KI9XzYNOEXbQEM";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON);